import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import InputTextJSX from './InputTextJSX';
import { adminMainUrl } from '../../../../Config';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import Beatloader from '../../../../Common/Loaders/Beatloader';

const EditAirline = ({ id, show, handleClose, token, user_id, refresh, loadingMasterAirlineDetail, MasterAirlineDetail }) => {
    const [disableSubmit, setDisableSubmit] = useState(false);

    let initialValues = {
        name: "",
        international_code: "",
        international_awb_perfix: "",
        international_awb_format: "",
        domestic_code: "",
        domestic_awb_perfix: "",
        domestic_awb_format: "",
        is_iata: false
    };


    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            // console.log(values);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                if (id) {
                    values.id = id
                } else {
                    toast.error("ID is required.");
                    return;
                }
                setDisableSubmit(true);
               
                axios.post(`${adminMainUrl}/api/master/airline/edit`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refresh();
                            // resetForm();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    let [showLoader, setShowLoader] = useState(false);
    useEffect(() => {
        if (loadingMasterAirlineDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (MasterAirlineDetail) {
            formik.setFieldValue("name", MasterAirlineDetail.name);
            formik.setFieldValue("international_code", MasterAirlineDetail.international_code);
            formik.setFieldValue("international_awb_perfix", MasterAirlineDetail.international_awb_perfix);
            formik.setFieldValue("international_awb_format", MasterAirlineDetail.international_awb_format);
            formik.setFieldValue("domestic_code", MasterAirlineDetail.domestic_code);
            formik.setFieldValue("domestic_awb_perfix", MasterAirlineDetail.domestic_awb_perfix);
            formik.setFieldValue("domestic_awb_format", MasterAirlineDetail.domestic_awb_format);
            formik.setFieldValue("is_iata", MasterAirlineDetail.is_iata);
        }
    }, [loadingMasterAirlineDetail, MasterAirlineDetail]);

    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <Offcanvas show={show} onHide={handleClose} placement={"end"} name={"end"}>
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Airline</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row">
                                    <InputTextJSX
                                        labelText={"Airline Name"}
                                        nameValue={"name"}
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                        maxLength={100}
                                    />
                                    <InputTextJSX
                                        labelText={"International Code"}
                                        nameValue={"international_code"}
                                        value={formik.values.international_code}
                                        onChange={formik.handleChange}
                                        maxLength={10}
                                    />
                                    <InputTextJSX
                                        labelText={"International AWB Prefix"}
                                        nameValue={"international_awb_perfix"}
                                        value={formik.values.international_awb_perfix}
                                        onChange={formik.handleChange}
                                        maxLength={10}

                                    />
                                    <InputTextJSX
                                        labelText={"International AWB Format"}
                                        nameValue={"international_awb_format"}
                                        value={formik.values.international_awb_format}
                                        onChange={formik.handleChange}
                                        maxLength={10}

                                    />
                                    <InputTextJSX
                                        labelText={"Domestic Code"}
                                        nameValue={"domestic_code"}
                                        value={formik.values.domestic_code}
                                        onChange={formik.handleChange}
                                        maxLength={10}

                                    />
                                    <InputTextJSX
                                        labelText={"Domestic AWB Prefix"}
                                        nameValue={"domestic_awb_perfix"}
                                        value={formik.values.domestic_awb_perfix}
                                        onChange={formik.handleChange}
                                        maxLength={10}

                                    />
                                    <InputTextJSX
                                        labelText={"Domestic AWB Format"}
                                        nameValue={"domestic_awb_format"}
                                        value={formik.values.domestic_awb_format}
                                        onChange={formik.handleChange}
                                        maxLength={10}

                                    />

                                    <div className={`col-md-6 mt-2 d-flex align-items-center`}>
                                        <div className='ms-2'>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <input
                                                    type="checkbox"
                                                    className="me-2"
                                                    id="is_iata"
                                                    name="is_iata"
                                                    checked={formik.values.is_iata}
                                                    onChange={(e) => {
                                                        formik.setFieldValue("is_iata", e.target.checked);
                                                    }}
                                                />
                                                <label htmlFor="" className='form-label  mb-0'>
                                                    IATA
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row d-flex justify-content-end mt-2">
                                        <div className="col-md-6 d-flex justify-content-end">
                                            <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                                {
                                                    disableSubmit ?
                                                        <>
                                                            <i className="fas fa-spinner fa-spin"></i> Saving...
                                                        </>
                                                        :
                                                        "Update"
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </Offcanvas.Body>
                    </Offcanvas>
            }

        </>
    )
}

export default EditAirline